let noHTML = function() {

  return function(text) {
    return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
  }

}

export default noHTML;



// WEBPACK FOOTER //
// ./client/app/common/filters/noHTML/noHTML.filter.js